import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  subcontractor: {
    async store(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.subcontractor.claims.lump-sum.claim.store'],
    ) {
      return await apiConfig(route('api.v1.subcontractor.claims.lump-sum.claim.store', claimId), 'post', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },

    async destroy(
      claimId: Id,
      signedParams: unknown,
      data: ApiRequests['api.v1.subcontractor.claims.lump-sum.claim.destroy'],
    ) {
      return await apiConfig(route('api.v1.subcontractor.claims.lump-sum.claim.destroy', claimId), 'delete', {
        params: signedParams,
        paramsSerializer: {
          serialize: (params) => {
            return new URLSearchParams(params).toString();
          },
        },
      }, {
        data,
      });
    },

    async storeCertified(
      projectId: Id,
      claimId: Id,
      id: Id,
      data: ApiRequests['api.v1.subcontractor.claims.lump-sum.certified.store'],
    ) {
      return await api(
        route('api.v1.subcontractor.claims.lump-sum.certified.store', [projectId, claimId, id]),
        'post',
        {
          data,
          casts: {
            comment_trade: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          },
        },
      );
    },
  },

  async store(
    claimId: Id,
    tradeItemId: Id,
    data: ApiRequests['api.v1.subcontractor.claims.lite.lump-sum.store'],
  ) {
    return await api(
      route('api.v1.subcontractor.claims.lite.lump-sum.store', [claimId, tradeItemId]),
      'post',
      {
        data,
        casts: {
          current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        },
      },
    );
  },

  async update(id: Id, data: ApiRequests['api.v1.lump-sum-costs.update']) {
    return await api(
      route('api.v1.lump-sum-costs.update', [id]),
      'patch',
      {
        data,
        casts: {
          current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        },
      },
    );
  },

  async updateComment(lumpSumCostId: Id, commentId: Id, data: ApiRequests['api.v1.lump-sum-costs.comments.update']) {
    return await api(route('api.v1.lump-sum-costs.comments.update', [lumpSumCostId, commentId]), 'patch', {
      data,
    });
  },

  async storeComment(lumpSumCostId: Id, data: ApiRequests['api.v1.lump-sum-costs.comments.store']) {
    return await api(route('api.v1.lump-sum-costs.comments.store', [lumpSumCostId]), 'post', {
      data,
    });
  },

  async deleteComment(lumpSumCostId: Id, commentId: Id) {
    return await api(route('api.v1.lump-sum-costs.comments.destroy', [lumpSumCostId, commentId]), 'delete');
  },

  async destroy(id: Id) {
    return await api(
      route('api.v1.lump-sum-costs.destroy', [id]),
      'delete',
    );
  },
};
